export default __webpack_public_path__ + "static/media/Snowflake_2.df7d8563.svg";